import Initial from './initial.vue'
export default Initial



// WEBPACK FOOTER //
// ./src/lib/components/node/initial/index.js